
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"608","height":"500","viewBox":"0 0 608 500","preserveAspectRatio":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M326.768 496.313C24.68 517.324 24.587 439.679 5.665 259.134-13.258 78.59 10.756-13.864 311.235 1.735c300.48 15.6 300.416 119.875 294.998 258.07C600.815 398 628.857 475.3 326.768 496.313z"}})])
          )
        }
      }
    